import { installNativeLifecycle } from "./utils/nativeApp";
import React from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/manrope';
import App from './App.tsx';
import './styles/index.css';
import "./styles/global.css";
import { ThemeProvider } from './context/ThemeContext';
import { initDatadogObservability } from './lib/datadog';
import { installProductionConsoleGuard } from './lib/logger';
import { installStaticApiRouter } from './utils/staticApiRouter';

void installNativeLifecycle().catch(() => console.error("Native lifecycle initialization failed"));
installStaticApiRouter();
initDatadogObservability();
installProductionConsoleGuard();

createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <ThemeProvider>
            <App />
        </ThemeProvider>
    </React.StrictMode>
);
